export enum PaymentStatusEnum {
  PENDING,
  PARTIALLY_PAID,
  PAID,
}
export enum DeliveryStatusEnum {
  PENDING,
  PARTIALLY_RECEIVED,
  RECEIVED,
}

export enum PurchaseOrderStatusEnum {
  DRAFT,
  AWAITING_APPROVAL,
  APPROVED,
  SENT_SUPPLIER,
  CLOSED,
  CANCELLED,
}

export enum LineTypeEnum {
  ITEM_LINE,
  ADDITIONAL_CHARGES,
}
